module.exports = __webpack_public_path__ + "img/Perseus.ee8a80dd.png";